import { clamper } from '../utils/clamper';
export function imagesCarousel() {
    // the exact values are calculated during init()
    let THUMBNAIL_WIDTH = 100;
    let THUMBNAIL_MARGIN = 20;
    function calculateMaxListOffset(pictureElements, thumbnails) {
        if (pictureElements.length <= 2) {
            return 0;
        }
        THUMBNAIL_WIDTH = pictureElements[0].getBoundingClientRect().width;
        THUMBNAIL_MARGIN = parseInt(window.getComputedStyle(pictureElements[1]).marginLeft.replace(/\D+$/, ''), 10);
        const maxThumbnailsOnScreen = Math.round(thumbnails.parentNode.getBoundingClientRect().width / (THUMBNAIL_WIDTH + THUMBNAIL_MARGIN));
        return Math.max(pictureElements.length - maxThumbnailsOnScreen, 0);
    }
    return {
        // list of URLs
        pictures: [],
        // current index in `pictures` to show in bigger size and zoomed popup
        currentIndex: 0,
        // thumbnails list offset
        listOffset: 0,
        listOffsetPx: 0,
        maxListOffset: 0,
        zoom: false,
        hidePopup: true,
        show: false,
        loadedImages: [],
        get mainImage() {
            var _a;
            // return a placeholder empty image until we have some data in pictures
            return (_a = this.pictures[this.currentIndex]) !== null && _a !== void 0 ? _a : 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACwAAAAAAQABAAACAkQBADs=';
        },
        get isLoaded() {
            return this.loadedImages.includes(this.currentIndex);
        },
        indexClamper: (value) => 0,
        listClamper: (value) => 0,
        init() {
            // @ts-ignore
            const thumbnailsEl = this.$refs.thumbnails;
            const pictureElements = Array.from(thumbnailsEl.querySelectorAll('.thumbnail'))
                .map(el => el);
            // @ts-ignore
            this.maxListOffset = calculateMaxListOffset(pictureElements, this.$refs.thumbnails);
            this.pictures = pictureElements.map(el => el.dataset.url);
            this.indexClamper = clamper(0, this.pictures.length - 1);
            this.listClamper = clamper(0, this.maxListOffset);
            setTimeout(() => this.show = true, 100);
        },
        imageLoaded(event) {
            this.loadedImages = [...this.loadedImages, this.currentIndex];
        },
        onThumbnailSelect(event) {
            const href = event.target.dataset.url;
            this.currentIndex = this.pictures.indexOf(href);
        },
        scrollZoomedImage(event) {
            this.currentIndex = this.indexClamper(this.currentIndex + Math.sign(event.deltaY));
        },
        moveList(offset) {
            this.listOffset = this.listClamper(this.listOffset + offset);
            this.listOffsetPx = -1 * this.listOffset * (THUMBNAIL_WIDTH + THUMBNAIL_MARGIN);
        },
        zoomImage() {
            this.hidePopup = false;
        },
        unZoomImage() {
            this.hidePopup = true;
        },
        prev() {
            this.currentIndex = (this.currentIndex - 1) < 0 ? this.pictures.length - 1 : this.currentIndex - 1;
        },
        next() {
            this.currentIndex = this.currentIndex >= this.pictures.length - 1 ? 0 : this.currentIndex + 1;
        },
    };
}
